// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
export interface Multilang {
  [props: string]: string;
}
export interface MultilangObj {
  [key: string]: any;
  id: number;
  names: Multilang;
}

export interface Language {
  id: number;
  name: string;
}

export interface Platform {
  id: number;
  names: Multilang;
  imageUrl: string;
  iconUrl: string;
}

export interface Level {
  id: number;
  level: string;
  names: Multilang;
}

export interface Domain {
  id: number;
  names: Multilang;
  imageUrl: string;
  iconUrl: string;
}

export interface Interest {
  id: number;
  names: Multilang;
}

export interface Expertise {
  id: number;
  names: Multilang;
}

export interface Job {
  id: number;
  names: Multilang;
}

export interface Industry {
  id: number;
  names: Multilang;
}

export interface Place {
  id: number;
  names: Multilang;
}

export type SupportType = 'I005' |'I006' |'I007' |'I010';

export enum SupportStateType {
  Open = 'Open',
  Processing = 'Processing',
  Closed = 'Closed'
}
export enum SupportMessageType {
  Text = 'text',
  Resolve = 'resolve',
}
export interface SupportReply {
  id: string;
  createdTime: Date;
  username: string;
  message: string;
  messageType?: SupportMessageType;
  imagesUrls: string[];
}
export interface Support {
  supportType: SupportType;
  supportStatus: SupportStateType;
  title: string;
  read: boolean;
  replies: SupportReply[];
  username: string;
  organizationId: number | null;
  id: number;
  createdTime: Date;
  revisedTime?: Date;
  memberId: number;
}
// export interface SupportReply {
//   message: string;
//   createdTime: Date;
// }

// export interface Support {
//   id: number;
//   revisedTime?: Date;
//   createdTime: Date;
//   title: string;
//   message: string;
//   state: SupportStateType;
//   replies: SupportReply[];
//   problemTypeId: number;
//   username: string;
// }

export interface CreditProduct {
  createdTime: Date;
  revisedTime: Date;
  id: number;
  credit: number;
  price: number;
  visibility: Visibility;
}

export interface Currency {
  id: number;
  name: string;
}

export function isOnlineCourseFavorite(favorite: Favorite): favorite is OnlineCourseFavorite {
  return 'onlineCourseId' in favorite;
}

interface OnlineCourseFavorite {
  onlineCourseId: number;
}

export function isLabFavorite(favorite: Favorite): favorite is LabFavorite {
  return 'labId' in favorite;
}

interface LabFavorite {
  labId: number;
}

export function isChallengeFavorite(favorite: Favorite): favorite is ChallengeFavorite {
  return 'challengeId' in favorite;
}

interface ChallengeFavorite {
  challengeId: number;
}

type Favorite = OnlineCourseFavorite | LabFavorite | ChallengeFavorite;

export const DEFAULT_MEMBER: Member = {
  id: -1,
  firstTime: false,
  favorites: [],
  email: '',
  username: '',
  firstName: '',
  lastName: '',
  gender: undefined,
  imageUrl: '',
  credit: 0,
  organizationCredit: 0,
  birthday: undefined,
  company: '',
  interestIds: [],
  expertiseIds: [],
  currencyId: undefined,
  industryId: undefined,
  jobId: undefined,
  placeId: undefined,
  roleId: 1,
  department: '',
  isManager: false,
  isReviewer: false,
  runningLab: null,
  runningChallenge: null,
  runningExam: null,
  newMessage: 0,
  roleName: null,
  organizationName: null,
}

export interface Member {
  id: number;
  firstTime: boolean;
  favorites: Favorite[];
  email: string;
  username: string;
  firstName: string;
  lastName: string;
  gender?: number;
  imageUrl: string;
  credit: number;
  organizationCredit: number;
  birthday?: Date;
  company: string;
  interestIds: number[];
  expertiseIds: number[];
  currencyId?: number;
  industryId?: number;
  jobId?: number;
  placeId?: number;
  roleId?: number;
  organizationId?: number;
  organizationRoleId?: number;
  department: string;
  newMessage: number;
  isManager: boolean;
  isReviewer: boolean;
  runningLab: RunningLab | null;
  runningChallenge: RunningLab | null;
  runningExam: RunningLab | null;
  organizationName: string | null;
  roleName: string | null;
}

export interface UpdateMember {
  id?: number;
  firstTime?: boolean;
  favorites?: Favorite[];
  email?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  gender?: number;
  imageUrl?: File;
  birthday?: string;
  company?: string;
  interestIds?: number[];
  expertiseIds?: number[];
  currencyId?: number;
  industryId?: number;
  jobId?: number;
  placeId?: number;
  roleId?: number;
}
export interface RunningLab {
  id: number;
  status: RunningLabStatus;
  recordId: number;
  sourceFrom: RunningLabSourceFrom;
  sourceId?: number;
}

export interface RunningChallenge {
  id: number;
  status: RunningChallengeStatus;
  recordId: number;
  sourceFrom: RunningChallengeSourceFrom;
  sourceId?: number;
}

export interface RunningExam {
  id: number;
  status: RunningExamStatus;
  recordId: number;
  sourceFrom: RunningExamSourceFrom;
  sourceId?: number;
}

export enum RunningLabStatus {
  Run = 'Run',
  Prewarm = 'Prewarm',
  Stop = 'Stop',
  Error = 'Error',
  Starting = 'Starting',
}

export enum RunningChallengeStatus {
  Run = 'Run',
  Prewarm = 'Prewarm',
  Stop = 'Stop',
  Error = 'Error',
  Starting = 'Starting',
}

export enum RunningExamStatus {
  Run = 'Run',
  Prewarm = 'Prewarm',
  Stop = 'Stop',
  Error = 'Error',
  Starting = 'Starting',
}

export enum RunningLabSourceFrom {
  Workshop = 'Workshop',
  Ilt = 'Ilt',
  Test = 'Test',
}

export enum RunningChallengeSourceFrom {
  Workshop = 'Workshop',
  Ilt = 'Ilt',
  Test = 'Test',
}

export enum RunningExamSourceFrom {
  Workshop = 'Workshop',
  Ilt = 'Ilt',
  Test = 'Test',
}

export type Instructor = string;

export enum VideoState {
  PROGRESSING = 'PROGRESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR'
}
export interface Vod {
  id: number;
  createdTime: Date;
  revisedTime?: Date;
  names: Multilang;
  code: string;
  language: string;
  instructors: string[];
  duration: number;
  videoUrl: string;
  platformId: number;
  domainIds: number[];
  visibility: Visibility;
  videoState: VideoState;
  tags: string[];
  description: string;
  subtitles: {
    [key: string]: string;
  }
}

export interface Quiz {
  id: number;
  code: string;
  createdTime: Date;
  revisedTime?: Date;
  names: Multilang;
  platformId: number;
  domainIds: number[];
  questions: Question[];
  winPoint: number;
  visibility: Visibility;
}

export interface Question {
  names: Multilang;
  options: QuestionOption[];
}

export interface QuestionOption {
  answers: Multilang;
  explanations: Multilang;
  isCorrect: boolean;
}

// Type for ManageLab
export interface Lab {
  id: number;
  createdTime: Date;
  revisedTime?: Date;
  code: string;
  names: Multilang;
  platformId: number;
  domainIds: number[];
  levelId: number;
  repositoryUrlPath: string;
  availableDuration: number;
  needAccessKey: boolean;
  needGitCredential: boolean;
  region: string;
  informationHtmls: Multilang;
  imageUrl: string;
  language: string;
  costCredit: number;
  winPoint: number;
  visibility: Visibility;
  tags: string[];
}

export enum CreditMethod {
  Member = 'Member',
  OrganizationCredit = 'OrganizationCredit',
}

export enum BuyCondition {
  Unlimit = 'unlimit',
  LabRecord = 'labRecord',
  Credit = 'credit'
}

export interface LabInformation {
  id: number;
  code: string;
  name: string;
  overview: string;
  duration: number;
  buyCondition: BuyCondition;
  labRecordCount?: number;
  costCredit?: number;
  organizationContactEmail: string;
  runningInfo: {
    markdownUrl: string;
    consoleUrl: string;
    startTime: Date;
    examRecordId: number;
    labInfo: {
      [key: string]: string;
      accessKeyId: string;
      secretAccessKey: string;
      gitUserName: string;
      gitPassword: string;
      loginLink: string;
    },
    labCredential: {
      sessionId: string;
      sessionKey: string;
      sessionToken: string;
    }
    accountInfo: {
      accountId: string;
      accountAlias: string;
    },
    labStatus: {
      cfnOutput: {
        [key: string]: string;
      },
      prewarming: boolean;
    }
  } | null;
  relatedWorkshop?: Workshop;
}

export interface ExamInformation extends LabInformation{
  multiSelectCount: string;
  qnaCount: string;
  visitor: number;
  level: number;
  title: string;
  isRemark?: boolean;
  isComplete?: boolean;
  choosedAnswer?: string[];
  examContent: [];
  passingScore: number;
}

// Type for Lab Search Result, RelatedLabList.
export interface LabCardType {
  id: number;
  names: Multilang;
  platformId: number;
  domainIds: number[];
  levelId: number;
  duration: number;
  reviewCount: number;
  reviewAverage: number;
  costCredit: number;
  imageUrl: string;
}

export interface ChallengeCardType {
  id: number;
  names: Multilang;
  platformId: number;
  domainIds: number[];
  levelId: number;
  duration: number;
  reviewCount: number;
  reviewAverage: number;
  costCredit: number;
  imageUrl: string;
}

export interface ExamCardType {
  id: number;
  names: Multilang;
  platformId: number;
  domainIds: number[];
  levelId: number;
  duration: number;
  reviewCount: number;
  reviewAverage: number;
  costCredit: number;
  imageUrl: string;
  examCount: number;
  examTotalCount: number;
}

export interface Option {
  option: string;
  isAnswer: boolean;
}

export interface AssessmentQuestion {
  single: boolean;
  question: string;
  options: Option[];
  explanation: string;
}

interface Assessment {
  assessmentId: number;
  createdTime: Date;
  updatedTime: Date;
  name: string;
  language: string;
  questions: AssessmentQuestion[];
  visibility: Visibility;
  tags: string[]
}

export enum ModuleType {
  EMPTY = '',
  VIDEO = 'vod',
  LAB = 'lab',
  QUIZ = 'quiz',
  ASSESSMENT = 'assessment',
  HYPERLINK = 'hyperlink',
  CHALLENGE = 'challenge',
  EXAM = 'exam',
  TEXT = 'text',
}

export interface EmptyModule {
  name: string;
  type: ModuleType.EMPTY;
}

export type ModuleStatus = CompletionStatusType.INCOMPLETE | CompletionStatusType.COMPLETED;

export interface Subtitles {
  [key: string]: string;
}

export interface VodModule {
  vodId: number;
  name: string;
  sample: boolean;
  type: ModuleType.VIDEO;
  duration?: number;
  videoUrls?: {
    dashIsoGroup: string;
    hlsGroup: VideoUrlType[];
  };
  status?: ModuleStatus;
  subtitles?: Subtitles;
}
export interface VideoUrlType {
  url: string;
  type: string;
}

export enum SubtitlesLang {
  ENGLISH = 'eng',
  CHINESE_TRADITIONAL = 'cht',
  NONE = 'none'
}
export interface LabModule {
  labId: number;
  name: string;
  type: ModuleType.LAB;
  duration?: number;
  status?: ModuleStatus;
}

export interface ChallengeModule {
  challengeId: number;
  name: string;
  type: ModuleType.CHALLENGE;
  duration?: number;
  status?: ModuleStatus;
}

export interface ExamModule {
  examId: number;
  name: string;
  type: ModuleType.EXAM;
  duration?: number;
  status?: ModuleStatus;
}

export interface HyperlinkModule {
  name: string;
  hyperlinkId?: string;
  type: ModuleType.HYPERLINK;
  link: string;
  status?: ModuleStatus;
}

export interface TextModule {
  name: string;
  type: ModuleType.TEXT;
  duration?: number;
  status?: ModuleStatus;
}

export interface AssessmentModule {
  assessmentId: number;
  name: string;
  type: ModuleType.ASSESSMENT;
  questions: AssessmentQuestion[];
  status?: ModuleStatus;
  score?:number;
}

export interface ExamData {
  title: string;
  options: string[];
}

export interface QuizModule {
  quizId: number;
  name: string;
  type: ModuleType.QUIZ;
  status?: ModuleStatus;
  duration?: number;
  examData?: ExamData[];
  answers?: string[];
  explains?: Array<{ [key: string]: string }>;
}

export type Module = VodModule | ChallengeModule | LabModule | QuizModule | HyperlinkModule | AssessmentModule | EmptyModule | ExamModule | TextModule;

export interface Chapter {
  name: string;
  modules: Module[];
  vodCount?: number;
  labCount?: number;
  challengeCount?: number;
  examCount?: number;
  examTotalCount?: number;
  quizCount?: number;
  assessmentCount?: number;
  totalDuration?: number;
}

export interface OnlineCourse {
  id: number;
  createdTime: Date;
  revisedTime?: Date;
  code: string;
  name: string;
  platformId: number;
  domainIds: number[];
  levelId: number;
  description: string;
  chapters: Chapter[];
  imageUrl: string;
  instructors: string[];
  totalDuration: number;
  visibility: Visibility;
  language: string;
  tags: string[];
  bannerUrl: string;
  vodCount?: number;
  labCount?: number;
  challengeCount?: number;
  assessmentCount?: number;
  examCount?: number;
  examTotalCount: number;
  completionProgress?: number | 0;
  hasCourse?: boolean;
  hasSample?: boolean;
  contactEmail?: string;
  courseUserList: string[];
  isCourseOwner: boolean;
}

export interface OnlineCourseGroup {
  id: number;
  name: string;
  onlineCourseIds: number[];
}

export interface VodProgress {
  vodId: number;
}

export interface LabProgress {
  labId: number;
}

export interface ChallengeProgress {
  challengeId: number;
}

export interface ExamProgress {
  examId: number;
}

export interface QuizProgress {
  quizId: number;
}

export interface HyperlinkProgress {
  hyperlinkId: string;
}

export interface AssessmentProgress {
  assessmentId: number;
  score: number;
}

export type Progress = VodProgress | LabProgress | QuizProgress | HyperlinkProgress | AssessmentProgress | ChallengeProgress | ExamProgress;

export interface OnlineCourseCard extends OnlineCourse {
  reviewAverage: number;
  reviewCount: number;
  price: number;
}

export interface ILTCourse {
  id: number;
  createdTime: Date;
  revisedTime?: Date;
  code: string;
  name: string;
  description: string;
  chapters: Chapter[];
  imageUrl: string;
  instructors: string[];
  totalDuration: number;
  visibility: Visibility;
  language: string;
  tags: string[];
  location: string;
  vodCount?: number;
  labCount?: number;
  challengeCount?: number;
  assessmentCount?: number;
  examCount?: number;
  examTotalCount: number;
  completionProgress?: number | 0;
  hasCourse?: boolean;
  hasSample?: boolean;
  contactEmail?: string;
  courseUserList: string[];
  isCourseOwner: boolean;
  startTime: Date;
  endTime: Date;
  checkInTime?: Date;
  checkOutTime?: Date;
}

/** @enum {string} */
export enum CardTypes {
  COURSE = 'onlineCourse',
  ILTCOURSE = 'iltCourse',
  LAB = 'lab',
  WORKSHOP = 'workshop',
  CHALLENGE = 'challenge',
  EXAM = 'exam'
}

export enum Visibility {
  Draft = 'Draft',
  Available = 'Available',
  Hidden = 'Hidden',
  Deleted = 'Deleted'
}

export interface PaginationListResponse<T> {
  list: T[];
  count: number;
  page: number;
  limit: number;
  totalPage: number;
}

export interface ListResponse<T> {
  list: T[];
}

export interface OnlineCourseHistory extends OnlineCourse {
  completedTime?: Date;
  progress: number; // 0~100
  certificationUrl?: string;
}

export interface LabHistory {
  id: number;
  name: string;
  duration: number;
  platformId: number;
  levelId: number;
  endTime?: Date;
}

export interface ChallengeHistory {
  id: number;
  name: string;
  duration: number;
  platformId: number;
  levelId: number;
  endTime?: Date;
}
export interface SandbagHistory {
  id: number;
  name: string;
  duration: number;
  platformId: number;
  levelId: number;
  endTime?: Date;
}
export interface PhysicalCourseHistory {
  id: number;
  name: string;
  instructors: string[];
  duration: number;
  platformId: number;
  levelId: number;
  completed: boolean;
  certificationUrl?: string;
}

export interface Permission extends TablePermission {
  id: number;
  name: string;
}

export interface TablePermission {
  tableName: string;
  remove: boolean;
  insert: boolean;
  view: string[];
  update: string[];
}

export interface PermissionOption {
  tableName: string;
  columns: string[];
}

export interface Role {
  id: number;
  name: string;
  permissionIds: number[];
}

export interface OnlineCourseGroup {
  id: number;
  name: string;
  onlineCourseIds: number[];
}

export interface ManageCommon {
  permissions: Permission[];
  roles: Role[];
  onlineCourses: OnlineCourse[];
  onlineCourseGroups: OnlineCourseGroup[];
  organizations: Organization[];
  departments: string[];
}

export interface Target {
  onlineCourseIds: number[];
  off: number;
  minus: number;
}

export interface Coupon {
  id: number;
  code: string;
  target: Target;
  names: Multilang;
  count: number;
  start: Date;
  end: Date;
  createdTime: Date;
  revisedTime?: Date;
  visibility: Visibility;
}

export interface MemberOnlineCourseOwn extends Member {
  onlineCourseIds: number[];
}

export interface Organization {
  id: number;
  name: string;
  organizationCode: string;
  ectMemberEmail: string;
  credit: number;
  onlineCourseIds: number[];
  totalUser: number;
  organizationContactEmail: string;
}

export interface MonthlyActiveUser {
  date: string;
  totalUser: number;
}

export interface OrganizationLog {
  id: number;
  credit: number;
  createdTime: Date;
  addedOnlineCourseNames: MultilangObj[];
  removedOnlineCourseNames: MultilangObj[];
  onlineCourseNames: MultilangObj[];
  organizationLogTotalUser: number;
  email: string;
  organizationName: string;
}
export interface NotificationLink {
  page?: string;
  id?: number;
}

type NotificationType = 'H002' | 'H004' | 'H006' | 'H008' | 'H012' | 'H015';

export interface NotificationProps {
  total?: number;
  name?: string;
  organizationName?: string;
  hasReply?: boolean;
  roleName?: string;
  examName?: string;
  reviewee?: string;
}
export interface Notification {
  id: number;
  notificationType: NotificationType;
  notificationProps: NotificationProps;
  time: Date;
  link?: NotificationLink;
  read: boolean;
}

export interface Workshop {
  id: number;
  createdTime: Date;
  revisedTime: Date;
  code: string;
  name: string;
  platformId: number;
  domainIds: number[];
  levelId: number;
  description: string;
  startTime: Date;
  endTime: Date;
  imageUrl: string;
  chapters: Chapter[];
  visibility: Visibility;
  bannerUrl: string;
  language: string;
  tags: string[];
  vodCount?: number;
  labCount?: number;
  challengeCount?: number;
  assessmentCount?: number;
  examCount?: number;
  examTotalCount: number;
  completionProgress?: number | 0;
  totalDuration: number;
  emails: string[];
  isWorkshopOwner?: boolean;
  workshopUserList: string[];
}

export type WorkshopManagement = Workshop & ManagementObj;

export interface ManagementObj {
  createdTime: Date;
  revisedTime?: Date;
  visibility: Visibility;
}
export interface WorkshopInformation extends Workshop {
  informations: Record<number, Workshop>;
  isFetching: boolean;
  error: Error | null;
}

export enum FileType {
  VIDEO = 'video',
  SUBTITLE = 'subtitle'
}

export enum CompletionStatusType {
  ENDED = 'Ended',
  COMPLETED = 'Complete',
  INCOMPLETE = 'Incomplete'
}

export enum HandsOnCompletionStatusType {
  ENDED = 'Stop',
  COMPLETED = 'Complete',
  INCOMPLETE = 'Incomplete',
  COMPLETED_PASS = 'Complete_pass',
  COMPLETED_NO_PASS = 'Complete_no_pass',
  REVIEWING = 'Reviewing',
  REVIEWED = 'Reviewed',
  NOREVIEW = 'NoReview',
}

export interface Note {
  id: string; // uuid-v4
  vodId: number;
  time: number;
  message: string;
}

export interface SearchCondition {
  name?: string;
  platformId?: number;
  domainIds: number[];
  levelId?: number;
}

export interface questionnaireImg {
  name: string;
  content: string;
  contentType: string;
}

export interface questionnairePayload {
  memberId: number;
  score: number;
  sourceId: number;
  sourceFrom: string;
  handsOnType: string;
  handsOnId: number;
  handsOnRecordId: number;
  comment: string;
  picture: questionnaireImg[];
}
